import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ArticleRegion } from '@app/modules/articles/models/article.model';
import { ArticlesService } from '@app/modules/articles/services/articles.service';
import { FormElement } from '@app/modules/form-generator/edit-form-v3/models/form.model';
import { PagedData } from '@app/modules/lookup/models/paged-data.model';
import { from, Observable } from 'rxjs';

@Component({
  selector: 'app-article-regions-form-field',
  templateUrl: './article-regions-form-field.component.html',
  styleUrls: ['./article-regions-form-field.component.scss']
})
export class ArticleRegionsFormFieldComponent implements OnInit {
  @Input() formElement: FormElement;
  @Input() parentGroup: UntypedFormGroup;
  @Input() readOnly: boolean;
  isLoading: boolean;
  user$: any;
  filterString: string;
  options: Observable<PagedData<ArticleRegion>>;

  constructor(
    private articlesService: ArticlesService,
  ) { }

  ngOnInit(): void {
    this.options = from(this.articlesService.getArticleRegions(100, 0))
  }
}